import { render, staticRenderFns } from "./ShowInstitutionCollectionPage.vue?vue&type=template&id=1d1a37b3&"
import script from "./ShowInstitutionCollectionPage.vue?vue&type=script&lang=js&"
export * from "./ShowInstitutionCollectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports